import React, { useEffect } from 'react';
import { useKeycloak } from '../services/KeycloakProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingSpinner } from './common/LoadingSpinner';

export function SignIn() {
  const { keycloak, authenticated } = useKeycloak();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authenticated) {
      const searchParams = new URLSearchParams(location.search);
      const redirectPath = searchParams.get('path') || '/';
      navigate(redirectPath);
    }
  }, [authenticated, navigate, location.search]);

  if (!authenticated) {
      keycloak.login();
      return <LoadingSpinner />;
  }

  return <LoadingSpinner />;
}
